import { type WebinarTimeslot } from '@/pages/api/hubspot/get-webinar-timeslots';
import { type WebinarRegion } from '@/utils/onboardingExperience';
import { useQuery } from '@tanstack/react-query';

export const GET_WEBINAR_TIMESLOTS = '/api/hubspot/get-webinar-timeslots';

interface WebinarTimeslotsResponse {
  success: boolean;
  timeslots?: WebinarTimeslot[];
  message?: string;
}

async function fetchWebinarTimeslots(
  region: WebinarRegion
): Promise<WebinarTimeslot[] | undefined> {
  const response = await fetch(`${GET_WEBINAR_TIMESLOTS}?region=${region}`);

  if (!response.ok) {
    return undefined;
  }

  const data = (await response.json()) as WebinarTimeslotsResponse;

  if (!data.success) {
    return undefined;
  }

  return data.timeslots;
}

export function useQueryWebinarTimeslots(region: WebinarRegion | undefined) {
  return useQuery({
    enabled: !!region,
    queryKey: [GET_WEBINAR_TIMESLOTS, region],
    queryFn: () => (region ? fetchWebinarTimeslots(region) : undefined),
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
